import { useMutation } from "@tanstack/react-query";
import { createPlan, type CreatePlanPayload } from "../api/planner";

export const useCreatePlan = () => {
    return useMutation({
        mutationFn: (payload: CreatePlanPayload) => createPlan(payload),
        throwOnError: false,
    });
};
